import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements OnInit {
    private _autofocus: boolean;

    constructor(
        private el: ElementRef
    ) {}

    public ngOnInit(): void {
        this.updateFocus();
    }

    @Input()
    set autofocus(condition: boolean | string | number) {
        this._autofocus = condition === '' || !!condition; // Empty string means using the directive without any value.
        this.updateFocus();
    }

    private updateFocus(): void {
        if (this._autofocus || this._autofocus === undefined) {
            this.el.nativeElement.focus();
            // For SSR (server side rendering) this is not safe.
            // Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070)
        }
    }
}
